<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid">
    <div class="faq-wrap">
      <div class="row">
       
      </div>
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <form @submit.prevent="findOrder">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <!-- <vue-feather class="m-r-30" type="search"></vue-feather> -->
                  <div class="media-body">
                    <h6 class="f-w-500"> </h6>
                    <div class="row">
                      <div class="d-flex justify-content-center">
                        <figure class="col-12">
                          <img :src="this.s3_url+'event/'+this.$route.params.event_key+'/cover.jpg'"  style="width: 100%;box-shadow: 0em 0em 1em rgb(0 0 0 / 50%);border-bottom-left-radius: 0.2em;border-bottom-right-radius: 0.2em;border: 0px;" alt="Image description"
                            class="img-thumbnail" />
                        </figure>
                    </div>
                      <div class="col-sm-12">
                        <b>{{this.currentLanguage ==='en'?'Find order application':'ตรวจสอบรายชื่อผู้สมัคร'}}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- <div class="form-check form-check-inline">
                        <input class="form-check-input" v-model="filter_type" checked required type="radio"
                          name="inlineRadioOptions" id="inlineRadio3" value="id_card">
                        <label class="form-check-label" for="inlineRadio3">
                          {{this.currentLanguage ==='en'?'Card No':'หมายเลขบัตรประชาชน'}}
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" v-model="filter_type"  required type="radio"
                          name="inlineRadioOptions" id="inlineRadio1" value="mobile_no">
                        <label class="form-check-label" for="inlineRadio1">
                          {{this.currentLanguage ==='en'?'Mobile no':'หมายเลขโทรศัพท์'}}
                        </label>
                      </div> -->
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" v-model="filter_type" checked type="radio"  required name="inlineRadioOptions"
                          id="inlineRadio2" value="full_name">
                        <label class="form-check-label" for="inlineRadio2">
                          {{this.currentLanguage ==='en'?'Name':'ชื่อ-สกุล ผู้สมัคร'}}
                        </label>
                      </div>
                      
                    </div>
                      <div class="mb-12 col-sm-12">
                        <input
                          required
                          maxlength="25"
                          :minlength="this.filter_type==='mobile_no'?10:this.filter_type==='id_card'?8:3"
                          type="text"
                          class="form-control"
                          :class="{'is-invalid': validation_message}"
                          :placeholder="this.currentLanguage ==='en'? (this.filter_type==='mobile_no'?'Mobile no':this.filter_type==='full_name'?'Name':'Card No/Passport') : (this.filter_type==='mobile_no'?'หมายเลขโทรศัพท์':this.filter_type==='full_name'?'ชื่อ-สกุล ผู้สมัคร':'หมายเลขบัตรประชาชน')"
                          v-model="txt_search"
                          @input="validateInput"
                        />
                        <div v-if="validation_message" class="invalid-feedback d-block" style="color: #dc3545; font-size: 14px; margin-top: 8px;">
                          <vue-feather type="alert-circle" size="16" style="margin-right: 5px;"></vue-feather>
                          {{ validation_message }}
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div class="row">&nbsp;</div>
                <div class="row">
                  <div class="d-flex justify-content-center gap-3">
                    <button
                      type="submit"
                      :disabled="validation_message || !txt_search"
                      :style="{ 
                             cursor: (validation_message || !txt_search) ? 'not-allowed' : 'pointer',
                             opacity: (validation_message || !txt_search) ? '0.6' : '1'
                      }"
                      class="btn btn-primary btn-lg"
                    >
                      <vue-feather type="search" size="18" style="margin-right: 8px;"></vue-feather>
                      {{this.currentLanguage ==='en'?'Search':'ค้นหา'}}
                    </button>
                    <button
                      @click.prevent="clear_result"
                      type="reset"
                      class="btn btn-secondary btn-lg"
                    >
                      <vue-feather type="x" size="18" style="margin-right: 8px;"></vue-feather>
                      {{this.currentLanguage ==='en'?'Cancel':'ยกเลิก'}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-sm-1"></div>
      </div>

      <div class="row" v-if="this.start_search === 'true'">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <div class="card">
            <div class="card-body">
              <div v-if="this.is_searching === 'true'">
                <div class="d-flex justify-content-center">
                  <img width="60" src="../../assets/images/running_loading.svg" />
                </div>
              </div>

              <div v-if="this.is_searching === 'false'">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{this.currentLanguage ==='en'?'Bib No.':'หมายเลขบิบ'}}</th>
                        <th scope="col">{{this.currentLanguage ==='en'?'Name':'ชื่อ-สกุล'}}</th>
                        <th scope="col" style="text-align: center;">{{this.currentLanguage ==='en'?'Gender':'เพศ'}}</th>
                        <th scope="col" style="text-align: center;">{{this.currentLanguage ==='en'?'Race Type':'ประเภทการเเข่งขัน'}}</th>
                        <th scope="col" style="text-align: center;">{{this.currentLanguage ==='en'?'Age Group':'รุ่นอายุ'}}</th>
                        <th scope="col" style="text-align: center;">{{this.currentLanguage ==='en'?'T-shirt':'ขนาดเสื้อ'}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="!this.resultList.length">
                        <td colspan="6" style="text-align: center">
                          {{this.currentLanguage ==='en'?'No participant found':'ไม่พบข้อมูลผู้สมัคร'}}
                        </td>
                      </tr>
                      <tr v-for="(src, index) in this.resultList" :key="index" v-else>
                        <td>BIB{{ src.bib_no === null ? '-' : src.bib_no }}</td>
                        <td>{{ src.full_name === null ? '-' : src.full_name }}</td>
                        <td style="text-align: center;">{{ src.sex === null ? '-' : src.sex }}</td>
                        <td style="text-align: center;">{{ src.run_type === null ? '-' : src.run_type }}</td>
                        <td style="text-align: center;">{{ src.group_age === null ? '-' : src.group_age }}</td>
                        <td style="text-align: center;">{{ src.t_shirt === null ? '-' : src.t_shirt }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-1"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { useHead } from '@vueuse/head'
import {computed, reactive } from 'vue'
export default {
  data() {
    return {
      email: "",
      txt_search: "",
      resultList: {},
      status: "",
      is_searching: "false",
      start_search: "false",
      currentLanguage: 'th',
      filter_type: "full_name",
      s3_url: process.env.VUE_APP_AWS_S3_URL,
      validation_message: ""
    };
  },
  setup() {
    useHead({
      title: computed(() => `ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH`),
      meta: [
        {
          name: `description`,
          content: computed(() => `'งานวิ่ง ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH'`),
        },
        {
          name: `keywords`,
          content: computed(() => `งานวิ่ง,ระบบรับสมัครงานวิ่ง,ค้นหาคำสั่งซื้อ,ค้นหารูปวิ่ง, หารูปวิ่ง,งานวิ่ง,runrace,runninghub,facesearch`),
        }
        ],
     
    })
  },
  async created(){
    this.currentLanguage = localStorage.getItem('currentLanguage');
  },
  watch: {
    filter_type() {
      this.validateInput();
    }
  },
  methods: {
    validateInput() {
      const length = this.txt_search.length;
      this.validation_message = "";
      
      if (length === 0) return;
      
      if (this.filter_type === 'mobile_no') {
        if (length < 10) {
          this.validation_message = this.currentLanguage === 'en' 
            ? `Please enter at least 10 digits (current: ${length})` 
            : `กรุณาป้อนหมายเลขโทรศัพท์อย่างน้อย 10 หลัก (ปัจจุบัน: ${length})`;
        }
      } else if (this.filter_type === 'id_card') {
        if (length < 8) {
          this.validation_message = this.currentLanguage === 'en' 
            ? `Please enter at least 8 characters (current: ${length})` 
            : `กรุณาป้อนหมายเลขบัตรประชาชนอย่างน้อย 8 หลัก (ปัจจุบัน: ${length})`;
        }
      } else if (this.filter_type === 'full_name') {
        if (length < 3) {
          this.validation_message = this.currentLanguage === 'en' 
            ? `Please enter at least 3 characters (current: ${length})` 
            : `กรุณาป้อนชื่อ-สกุลอย่างน้อย 3 ตัวอักษร (ปัจจุบัน: ${length})`;
        }
      }
    },
    async findOrder() {
      // Validate input before searching
      this.validateInput();
      if (this.validation_message) {
        return; // Don't submit if validation fails
      }
      
      this.start_search = "true";
      this.resultList = {};
      this.is_searching = "true";

      
      const data = {
        tk: process.env.VUE_APP_FN_TO_BK_SECRET_KEY,
        event_key: this.$route.params.event_key,
        txt_search: this.txt_search,
        filter_type: this.filter_type
      };
      let result = await axios.post("/v1/participant/check", data);
      this.status = result.data.status;
      if (result.data.status === "success") {
        this.resultList = result.data.body;
      }
      this.is_searching = "false";
    },
    async clear_result() {
      this.start_search = "false";
      this.resultList = {};
      this.txt_search = "";
      this.validation_message = "";
    },
  },
};
</script>